/* eslint-disable no-underscore-dangle */
import consumer from 'channels/consumer';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = { channel: String, id: String };

  initialize() {
    this.subscription = consumer.subscriptions.create(
      {
        channel: this.channelValue,
        id: this.idValue,
      },
      {
        connected: this._connected.bind(this),
        disconnected: this._disconnected.bind(this),
        received: this.received.bind(this),
      }
    );
  }

  _connected() {}

  _disconnected() {}

  received(data) {
    if (data.status === 'success') {
      this.dispatch('received');
    } else {
      alert('Unable to process activity list. Please update and try again.');
    }
  }
}
